import { usePrescreeningState } from "../prescreening/utils/prescreeningStorage";
import { ClipboardList } from "lucide-react";

export function PrescreeningTab() {
  const { questionnaireState } = usePrescreeningState();

  return (
    <div className="p-4">
      <div className="flex items-center mb-2 text-blue-600">
        <ClipboardList size={16} className="mr-2" />
        <h4 className="text-sm font-medium">Questionnaire In Progress</h4>
      </div>

      <div className="text-xs text-gray-500 mb-4">
        This shows the current state of the questionnaire that the patient is
        filling out.
      </div>

      {questionnaireState && (
        <div className="space-y-4">
          <div className="bg-gray-50 p-2 rounded text-xs">
            <div className="font-medium mb-1">Questionnaire Progress</div>
            <div>
              <span className="font-medium">Current Question:</span>{" "}
              {(questionnaireState.currentQuestionIndex ?? 0) + 1}
            </div>
            <div>
              <span className="font-medium">Answered Questions:</span>{" "}
              {Object.keys(questionnaireState.answers || {}).length}
            </div>
            <div>
              <span className="font-medium">Disqualified:</span>{" "}
              {questionnaireState.isDisqualified ? "Yes" : "No"}
            </div>

            {questionnaireState.isDisqualified &&
              questionnaireState.disqualifyMessage && (
                <div className="mt-1 text-red-500">
                  <span className="font-medium">Disqualification Reason:</span>{" "}
                  {questionnaireState.disqualifyMessage}
                </div>
              )}
          </div>

          <div className="bg-gray-50 p-2 rounded text-xs overflow-auto">
            <div className="font-medium mb-1">Raw State Data</div>
            <pre className="whitespace-pre-wrap">
              {JSON.stringify(questionnaireState, null, 2)}
            </pre>
          </div>
        </div>
      )}

      {!questionnaireState && (
        <div className="text-center py-4 text-gray-500 text-xs">
          No active questionnaire being filled out on this page.
        </div>
      )}
    </div>
  );
}
